import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useQuery } from '../common/hooks/location';
import Loader from '@lwt-helix/loader';
import { useAuthStore } from '../store/auth/store';

const Auth = () => {
    const { initPlatform } =
        useAuthStore(({ initPlatform }) => ({ initPlatform }));

    const query = useQuery();
    const history = useHistory();
    const activeClientId = query.get('ac');
    const redirectPath = query.get('redirect');

    useEffect(() => {
        const initPlatformClient = async activeClientId => {
            await initPlatform({history, activeClientId, redirectPath});
        };
        initPlatformClient(activeClientId);
    }, [initPlatform, history, activeClientId, redirectPath]);

    return (
        <div className='d-flex flex-grow-1 align-items-center justify-content-center'>
            <Loader />
        </div>
    );
};

export default Auth;
